"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeploymentsService = void 0;
class DeploymentsService {
    constructor(httpRequest) {
        this.httpRequest = httpRequest;
    }
    /**
     * Returns a list of deployments.
     * @param groupId
     * @param creatorId
     * @param page
     * @param count
     * @returns DeploymentsResponse
     * @throws ApiError
     */
    getDeployments(groupId, creatorId, page, count) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/deployments',
            query: {
                'groupId': groupId,
                'creatorId': creatorId,
                'page': page,
                'count': count,
            },
        });
    }
    /**
     * Queue deployments for tracking
     * @returns any Successful response
     * @throws ApiError
     */
    queueDeploymentTracking() {
        return this.httpRequest.request({
            method: 'POST',
            url: '/deployments/track',
        });
    }
    /**
     * Queue deployments for emails
     * @returns any Successful response
     * @throws ApiError
     */
    queueDeploymentEmails() {
        return this.httpRequest.request({
            method: 'POST',
            url: '/deployments/outreach',
        });
    }
    /**
     * Queue single deployment emails
     * @param id
     * @returns any Successful response
     * @throws ApiError
     */
    queueSingleDeploymentEmails(id) {
        return this.httpRequest.request({
            method: 'POST',
            url: '/deployments/outreach/{id}',
            path: {
                'id': id,
            },
        });
    }
    /**
     * Get deployment information
     * @param id
     * @returns DeploymentResponse
     * @throws ApiError
     */
    getDeployment(id) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/deployments/{id}',
            path: {
                'id': id,
            },
        });
    }
    /**
     * Update deployment information
     * @param id
     * @param requestBody
     * @returns DeploymentResponse
     * @throws ApiError
     */
    updateDeployment(id, requestBody) {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/deployments/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Get deployment payment information
     * @param id
     * @returns DeploymentPaymentResponse
     * @throws ApiError
     */
    getDeploymentPayment(id) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/deployments/{id}/payment',
            path: {
                'id': id,
            },
        });
    }
    /**
     * Get deployment information
     * @param id
     * @returns DeploymentTreeResponse
     * @throws ApiError
     */
    getExtendedDeployment(id) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/deployments/extended/{id}',
            path: {
                'id': id,
            },
        });
    }
    /**
     * Get deployment for emails
     * @param id
     * @returns DeploymentEmailResponse
     * @throws ApiError
     */
    getDeploymentForEmails(id) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/deployments/emails/{id}',
            path: {
                'id': id,
            },
        });
    }
    /**
     * Update deployment custom fields
     * @param id
     * @param requestBody
     * @returns any Successful response
     * @throws ApiError
     */
    updateDeploymentCustomFields(id, requestBody) {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/deployments/{id}/custom-fields',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Configuration Update Preview
     * @param id
     * @param endDate
     * @param daysToDelay
     * @param paymentDueDateDelay
     * @returns DeploymentConfigurationPreviewResponse
     * @throws ApiError
     */
    getConfigurationUpdatePreview(id, endDate, daysToDelay, paymentDueDateDelay) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/deployments/{id}/configuration-update-preview',
            path: {
                'id': id,
            },
            query: {
                'endDate': endDate,
                'daysToDelay': daysToDelay,
                'paymentDueDateDelay': paymentDueDateDelay,
            },
        });
    }
    /**
     * Add Deliverable to Deployment
     * @param id
     * @param requestBody
     * @returns any Successful response
     * @throws ApiError
     */
    addDeliverableToDeployment(id, requestBody) {
        return this.httpRequest.request({
            method: 'POST',
            url: '/deployments/{id}/deliverables',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Delete Deliverable from Deployment
     * @param id
     * @param deliverableId
     * @returns any Successful response
     * @throws ApiError
     */
    deleteDeliverableFromDeployment(id, deliverableId) {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/deployments/{id}/deliverables/{deliverableId}',
            path: {
                'id': id,
                'deliverableId': deliverableId,
            },
        });
    }
    /**
     * Log manual outreach
     * @param id
     * @param requestBody
     * @returns DeploymentResponse
     * @throws ApiError
     */
    logDeploymentManualOutreach(id, requestBody) {
        return this.httpRequest.request({
            method: 'POST',
            url: '/deployments/{id}/log-manual-outreach',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Log email outreach
     * @param id
     * @param requestBody
     * @returns DeploymentResponse
     * @throws ApiError
     */
    logDeploymentEmailOutreach(id, requestBody) {
        return this.httpRequest.request({
            method: 'POST',
            url: '/deployments/{id}/log-email-outreach',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Log workflow engine email outreach
     * @param id
     * @param requestBody
     * @returns DeploymentResponse
     * @throws ApiError
     */
    logDeploymentWorkflowEngineEmailOutreach(id, requestBody) {
        return this.httpRequest.request({
            method: 'POST',
            url: '/deployments/{id}/log-workflow-engine-email-outreach',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Accept offer
     * @param id
     * @param requestBody
     * @returns DeploymentResponse
     * @throws ApiError
     */
    acceptDeploymentOffer(id, requestBody) {
        return this.httpRequest.request({
            method: 'POST',
            url: '/deployments/{id}/accept',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Start deployment
     * @param id
     * @returns DeploymentResponse
     * @throws ApiError
     */
    startDeployment(id) {
        return this.httpRequest.request({
            method: 'POST',
            url: '/deployments/{id}/start',
            path: {
                'id': id,
            },
        });
    }
    /**
     * Complete deployment
     * @param id
     * @param requestBody
     * @returns DeploymentResponse
     * @throws ApiError
     */
    completeDeployment(id, requestBody) {
        return this.httpRequest.request({
            method: 'POST',
            url: '/deployments/{id}/complete',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Reject reasons
     * @param id
     * @returns DeploymentInternalRejectReasons
     * @throws ApiError
     */
    getRejectReasons(id) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/deployments/{id}/reject-reasons',
            path: {
                'id': id,
            },
        });
    }
    /**
     * Reject offer
     * @param id
     * @param requestBody RejectDeploymentPayload
     * @returns any Successful response
     * @throws ApiError
     */
    rejectDeploymentOffer(id, requestBody) {
        return this.httpRequest.request({
            method: 'POST',
            url: '/deployments/{id}/reject',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Mark deployment is ready to outreach
     * @param id
     * @returns DeploymentResponse
     * @throws ApiError
     */
    outreachingDeployment(id) {
        return this.httpRequest.request({
            method: 'POST',
            url: '/deployments/{id}/outreaching',
            path: {
                'id': id,
            },
        });
    }
    /**
     * Resume offer / deployment
     * @param id
     * @param requestBody
     * @returns any Successful response
     * @throws ApiError
     */
    resumeOfferOrDeployment(id, requestBody) {
        return this.httpRequest.request({
            method: 'POST',
            url: '/deployments/{id}/resume',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Revise adjustment on completed deployment
     * @param id
     * @param requestBody
     * @returns any Successful response
     * @throws ApiError
     */
    adjustDeployment(id, requestBody) {
        return this.httpRequest.request({
            method: 'POST',
            url: '/deployments/{id}/payment/adjustments',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Approve (and possibly revise) adjustment on completed deployment
     * @param id
     * @param requestBody
     * @returns any Successful response
     * @throws ApiError
     */
    adjustCompletedDeployment(id, requestBody) {
        return this.httpRequest.request({
            method: 'POST',
            url: '/deployments/{id}/payment/adjustment-approve',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Finance approve payment
     * @param id
     * @returns any Successful response
     * @throws ApiError
     */
    financeApprovePayment(id) {
        return this.httpRequest.request({
            method: 'POST',
            url: '/deployments/{id}/payment/finance-approve',
            path: {
                'id': id,
            },
        });
    }
    /**
     * Finance reject payment
     * @param id
     * @returns any Successful response
     * @throws ApiError
     */
    financeRejectPayment(id) {
        return this.httpRequest.request({
            method: 'POST',
            url: '/deployments/{id}/payment/finance-reject',
            path: {
                'id': id,
            },
        });
    }
    /**
     * Returns a list of feedback questions to display when the deployment is completed
     * @param id
     * @returns DeploymentFeedbackQuestionsResponse
     * @throws ApiError
     */
    getDeploymentFeedbackQuestions(id) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/deployments/{id}/feedback',
            path: {
                'id': id,
            },
        });
    }
    /**
     * Sync deployments payment processing
     * @returns any Successful response
     * @throws ApiError
     */
    deploymentsControllerSyncDeploymentsPaymentProcessing() {
        return this.httpRequest.request({
            method: 'POST',
            url: '/deployments/sync-deployments-payment-processing',
        });
    }
    /**
     * Auto expire or complete
     * @returns any Successful response
     * @throws ApiError
     */
    deploymentsControllerAutoExpireOrComplete() {
        return this.httpRequest.request({
            method: 'POST',
            url: '/deployments/expire-offers',
        });
    }
    /**
     * Auto complete awaiting conclusions
     * @returns any Successful response
     * @throws ApiError
     */
    deploymentsControllerAutoCompleteAwaitingConclusions() {
        return this.httpRequest.request({
            method: 'POST',
            url: '/deployments/auto-complete-awaiting-conclusions',
        });
    }
    /**
     * Calculate roas
     * @returns any Successful response
     * @throws ApiError
     */
    deploymentsControllerCalculateRoas() {
        return this.httpRequest.request({
            method: 'POST',
            url: '/deployments/calculate-roas',
        });
    }
    /**
     * Auto start offers
     * @returns any Successful response
     * @throws ApiError
     */
    deploymentsControllerAutoStartOffers() {
        return this.httpRequest.request({
            method: 'POST',
            url: '/deployments/auto-start-offers',
        });
    }
    /**
     * trigger deployment webhooks by deployment state
     * @param id
     * @param requestBody
     * @returns any Successful response
     * @throws ApiError
     */
    triggerDeploymentWebhooks(id, requestBody) {
        return this.httpRequest.request({
            method: 'POST',
            url: '/deployments/{id}/webhooks',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * bulk update for deployments
     * @param requestBody
     * @returns BulkUpdateResponse
     * @throws ApiError
     */
    bulkUpdateEs(requestBody) {
        return this.httpRequest.request({
            method: 'POST',
            url: '/deployments/bulk-update-es',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * bulk update for deployments by ids
     * @param limit
     * @param requestBody
     * @returns BulkUpdateResponse
     * @throws ApiError
     */
    bulkUpdateByIds(limit, requestBody) {
        return this.httpRequest.request({
            method: 'POST',
            url: '/deployments/bulk-update-ids',
            query: {
                'limit': limit,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Get manual template for deployment
     * @param id
     * @returns ManualTemplatesResponse
     * @throws ApiError
     */
    getManualTemplates(id) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/deployments/{id}/manual-template',
            path: {
                'id': id,
            },
        });
    }
    /**
     * Get deployment timeline
     * @param id
     * @returns DeploymentTimelineResponse
     * @throws ApiError
     */
    getDeploymentTimeline(id) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/deployments/{id}/timeline',
            path: {
                'id': id,
            },
        });
    }
    /**
     * Get manual workflow progress for deployment
     * @param id
     * @returns ManualWorkflowProgress
     * @throws ApiError
     */
    getDeploymentManualWorkflowProgress(id) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/deployments/{id}/manual-workflow-progress',
            path: {
                'id': id,
            },
        });
    }
    /**
     * Returns available deployment labels terms information
     * @param string
     * @param size
     * @returns SearchTermsResponse
     * @throws ApiError
     */
    getDeploymentsLabelsTerms(string, size) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/deployments/labels/terms',
            query: {
                'string': string,
                'size': size,
            },
        });
    }
    /**
     * Update totals
     * @param id
     * @returns any Successful response
     * @throws ApiError
     */
    deploymentsControllerUpdateTotals(id) {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/deployments/{id}/totals',
            path: {
                'id': id,
            },
        });
    }
    /**
     * Update stats
     * @param id
     * @returns any Successful response
     * @throws ApiError
     */
    deploymentsControllerUpdateStats(id) {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/deployments/{id}/recalc-stats',
            path: {
                'id': id,
            },
        });
    }
    /**
     * Update a deployment revenue
     * @param id
     * @returns any Successful response
     * @throws ApiError
     */
    updateDeploymentRevenue(id) {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/deployments/{id}/recalc-revenue',
            path: {
                'id': id,
            },
        });
    }
    /**
     * Get deployment revenue(s)
     * @param id
     * @returns DeploymentRevenueResponse
     * @throws ApiError
     */
    getDeploymentRevenue(id) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/deployments/{id}/revenues',
            path: {
                'id': id,
            },
        });
    }
    /**
     * Calculate revenues on deployments updated within a recent time frame
     * @param seconds
     * @returns any Successful response
     * @throws ApiError
     */
    updateDeploymentsRevenueRecent(seconds) {
        return this.httpRequest.request({
            method: 'POST',
            url: '/deployments/recalc-revenues',
            query: {
                'seconds': seconds,
            },
        });
    }
    /**
     * Regenerate attribution link
     * @param id
     * @param requestBody
     * @returns any Successful response
     * @throws ApiError
     */
    deploymentsControllerRegenerateAttributionLink(id, requestBody) {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/deployments/{id}/regen-attribution-link',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Sends email to creator and log
     * @param id
     * @param requestBody
     * @returns GeneralResponse
     * @throws ApiError
     */
    sendDeploymentEmail(id, requestBody) {
        return this.httpRequest.request({
            method: 'POST',
            url: '/deployments/{id}/outreach',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Marks whether this deployment is to be paid for by the client
     * @param id
     * @param requestBody
     * @returns any Successful response
     * @throws ApiError
     */
    markDeploymentCharged(id, requestBody) {
        return this.httpRequest.request({
            method: 'POST',
            url: '/deployments/{id}/charged',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * sets the client-not-charged flag. If set, the revenue reported will be 0
     * @param id
     * @param requestBody
     * @returns any Successful response
     * @throws ApiError
     */
    setClientNotCharged(id, requestBody) {
        return this.httpRequest.request({
            method: 'POST',
            url: '/deployments/{id}/no-charge',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Trigger MixMax sequence to send emails
     * @param id
     * @param requestBody
     * @returns GeneralResponse
     * @throws ApiError
     */
    triggerMixMaxSequence(id, requestBody) {
        return this.httpRequest.request({
            method: 'POST',
            url: '/deployments/{id}/mixmax-sequence',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Get deployment outreach variables
     * @param id
     * @returns DeploymentVariablesResponse
     * @throws ApiError
     */
    getDeploymentVariables(id) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/deployments/{id}/variables',
            path: {
                'id': id,
            },
        });
    }
}
exports.DeploymentsService = DeploymentsService;
